(() => {
  const init = () => {
    const form = document.querySelector('.pf-newsletter__form');
    if (!form || form.dataset.pfNewsletterReady) return;
    form.dataset.pfNewsletterReady = 'true';
    const email = form.querySelector('[name="contact[email]"]');
    const consent = form.querySelector('.pf-newsletter__consent');
    const button = form.querySelector('[type="submit"]');
    const emailError = form.querySelector('#ContactFooter-client-error');
    const consentError = form.querySelector('#ContactFooter-consent-error');
    const serverError = form.querySelector('#ContactFooter-error');
    const originalLabel = button.textContent.trim();
    let resetTimer;
    const reset = () => {
      clearTimeout(resetTimer);
      form.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    };
    const showValidity = (field, message, copy) => {
      const invalid = !field.validity.valid;
      field.dataset.touched = 'true';
      message.textContent = invalid ? copy : '';
      message.hidden = !invalid;
      if (invalid || (field === email && serverError)) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
    };
    const emailValidity = () => showValidity(email, emailError, email.validity.valueMissing ? 'Introduce tu correo electrónico para suscribirte.' : 'Revisa el correo electrónico. Por ejemplo: tu@correo.com.');
    const consentValidity = () => showValidity(consent, consentError, 'Marca la casilla si quieres recibir nuestras novedades por correo.');
    email.addEventListener('blur', emailValidity);
    email.addEventListener('invalid', emailValidity);
    email.addEventListener('input', () => { reset(); if (email.dataset.touched) emailValidity(); });
    consent.addEventListener('invalid', consentValidity);
    consent.addEventListener('change', () => { reset(); if (consent.dataset.touched) consentValidity(); });
    form.addEventListener('submit', event => {
      // Keep Shopify's native POST and spam challenge in control: no preventDefault,
      // no disabled controls, and no flag that could reject a challenge resubmission.
      // A later task also observes cancellation by listeners registered after ours.
      setTimeout(() => {
        if (event.defaultPrevented) return reset();
        clearTimeout(resetTimer);
        form.setAttribute('aria-busy', 'true');
        button.textContent = 'Enviando…';
        resetTimer = setTimeout(reset, 15000);
      }, 0);
    });
    const focusResult = () => {
      const result = form.querySelector('#ContactFooter-success, #ContactFooter-error');
      if (result) requestAnimationFrame(() => result.focus());
    };
    window.addEventListener('pageshow', () => { reset(); focusResult(); });
    focusResult();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
